<template>
  <div class="trade">
    <i class="el-icon-arrow-left" v-if="trade_flow.length > 5"  @click="changeMargin('left')"></i>
    <ul>
      <li v-for="item,index in trade_flow" :style="`margin-left:${index===0?marginLeft:''}px`">
        <div class="trade_t">
          <p>{{index+1}}</p>
          <p>{{item.name}}</p>
        </div>
        <div class="trade_b">
          {{item.content}}
        </div>
      </li>
    </ul>
    <i class="el-icon-arrow-right" v-if="trade_flow.length > 5"  @click="changeMargin('right')"></i>
  </div>
</template>

<script>
  export default {
    props:{
      trade_flow:{
        type: Array
      }
    },
    data(){
      return{
        marginLeft: 0,
        w: 240,
        len: 5
      }
    },
    methods:{
      changeImage(index){
        this.itemShow = index
      },
      changeMargin(key){
        if(key==='left'){
          if(this.marginLeft < 0){
            if(this.trade_flow.length - (this.trade_flow.length + (this.marginLeft / this.w)) > 3){
              this.marginLeft += this.w * this.len;
            }else{
              let len = this.trade_flow.length - (this.trade_flow.length + (this.marginLeft / this.w));
              this.marginLeft += this.w * len;
            }

          }
        }else{
          let max = this.trade_flow.length > this.len ? (this.trade_flow.length-this.len) * this.w * -1 : 0;
          if(this.marginLeft > max){
            if(this.trade_flow.length-(this.marginLeft * -1 / this.w) > 7){
              this.marginLeft -= this.w * this.len;
            } else {
              let len = this.trade_flow.length-(this.marginLeft * -1 / this.w) - this.len;
              this.marginLeft -= this.w * len;
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .trade {
    width: 100%;
    position: relative;

    i {
      width: 14px;
      height: 25px;
      font-size: 30px;
      position: absolute;
      top: 66px;
      bottom: 0px;
      color: #C7CCD5;
      cursor: pointer;
      text-align: center;
    }

    i:first-child {
      left: -22px;
    }

    i:last-child {
      right: -9px;
    }

    i:hover {
      color: #ff733c;
    }


    ul {
      position: absolute;
      left: 0px;
      overflow: hidden;
      width: 100%;
      font-size: 0px;
      white-space: nowrap;
    }

    ul li {
      width: 240px;
      /*box-sizing: border-box;*/
      display: inline-block;
      vertical-align: top;
      white-space: initial;
      transition: all 0.2s;
    }

    ul li div.trade_t {
      text-align: center;
      border-bottom: 1px solid #E7E9EC;
      box-sizing: border-box;

      p:first-child {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #42424E;
        font-size: 16px;
        text-align: center;
        line-height: 28px;
        color: #fff;
        margin: 0 auto;
      }

      p:last-child {
        font-size: 16px;
        color: #4B5062;
        padding: 14px 0;
      }
    }

    ul li div.trade_b {
      font-size: 14px;
      color: #9499A5;
      line-height: 22px;
      text-align: center;
      padding: 14px 30px;
    }
  }
</style>